import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { KatButton, KatIcon } from '@amzn/katal-react';

import Tippy from '@tippyjs/react';
import { UserDetails } from 'src/state/slice/models/CaseLifecycleTypes';

interface ActionColumnFormatterProps {
  userDetails: UserDetails;
  onDeleteUser: Function;
}

const ActionColumnFormatterContainer = styled.div`
  kat-icon {
    --color: #cc0c39;
  },
  position: relative;
`;

const ConfirmationDialogLayout = styled.div`
  border: 1px solid black;
  background-color: white;
  font-size: 14px;
  padding: 0.5rem;
  .body {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.3rem;
  }
`;

export const ActionColumnFormatter: React.FC<ActionColumnFormatterProps> = ({
  userDetails,
  onDeleteUser,
}) => {
  const tippyRef = useRef<any>();
  const { userId, isInternalUser, fullName, role } = userDetails;

  const [visible, setVisible] = useState(false);
  const identifierString = fullName
    ? `Name: ${fullName}`
    : `User Id: ${userId}`;

  const onDelete = () => {
    setVisible(false);
    onDeleteUser(userDetails);
  };
  const confirmationDialog = (
    <ConfirmationDialogLayout>
      <div className="body">{`Do you want to delete the User with ${identifierString}`}</div>
      <div className="footer">
        <KatButton label="Yes" onClick={onDelete} />
      </div>
    </ConfirmationDialogLayout>
  );
  return (
    <ActionColumnFormatterContainer>
      <Tippy
        ref={tippyRef}
        content={confirmationDialog}
        visible={visible}
        onClickOutside={() => setVisible(false)}
        allowHTML={true}
        arrow={false}
        appendTo={document.body}
        interactive={true}
        placement="right"
      >
        <KatIcon name="x" size="small" onClick={() => setVisible(true)} />
      </Tippy>
    </ActionColumnFormatterContainer>
  );
};
